import { render, staticRenderFns } from "./purchase_order_wait_delivery_detail.vue?vue&type=template&id=3b61466c&scoped=true"
import script from "./purchase_order_wait_delivery_detail.vue?vue&type=script&lang=js"
export * from "./purchase_order_wait_delivery_detail.vue?vue&type=script&lang=js"
import style0 from "./purchase_order_wait_delivery_detail.vue?vue&type=style&index=0&id=3b61466c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61466c",
  null
  
)

export default component.exports